import ACTIONS from "./types";
import axios from "axios";
import API_ENDPOINTS from "../../configs/API_ENDPOINTS";
import Compress from "compress.js";
const imageCompressor = new Compress();

export const createNewInstallationOrder = (newOrder) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.CREATE_NEW_INSTALLATION_ORDER_START,
  });
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(`${API_ENDPOINTS.INSTALLATION}`, { ...newOrder });
      dispatch({
        type: ACTIONS.INSTALLATION.CREATE_NEW_INSTALLATION_ORDER,
        payload: res.data,
      });
      return resolve(res.data);
    } catch (err) {
      dispatch({
        type: ACTIONS.INSTALLATION.CREATE_NEW_INSTALLATION_ORDER_FAILURE,
        payload: err,
      });
      return reject(err);
    }
  });
};

export const getAllInstallationOrder =
  (queryParams = "", page = 1, limit = 25) =>
  (dispatch) => {
    dispatch({
      type: ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_START,
    });
    const separator = queryParams.length > 0 ? "&" : "";
    axios
      .get(`${API_ENDPOINTS.INSTALLATION}?${queryParams}${separator}page=${page}&limit=${limit}`)
      .then((res) => {
        const orders = res.data.data.map((IO) => {
          const _installedDevices = IO.devices.filter((d) => d.state.slug === "dlc_installed");
          return {
            ...IO,
            installedDevicesCount: _installedDevices.length,
          };
        });
        dispatch({
          type: ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER,
          payload: { data: [...orders], total: res.data.total },
        });
        return res.data;
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_FAILURE,
          payload: err,
        });
      });
  };

export const archiveInstallationOrder = (selectedInstallationOrderDetails) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.ARCHIVE_INSTALLATION_ORDER_START,
  });
  return axios
    .patch(`${API_ENDPOINTS.INSTALLATION}/${selectedInstallationOrderDetails._id}/archive`)
    .then((res) => {
      dispatch({
        type: ACTIONS.INSTALLATION.ARCHIVE_INSTALLATION_ORDER,
        payload: { ...res.data.installationOrder },
      });
      // getAllInstallationOrder()(dispatch);
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.INSTALLATION.ARCHIVE_INSTALLATION_ORDER_FAILURE,
      });
    });
};

export const startInstallationOrder = (installationOrder) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.START_INSTALLATION_ORDER,
  });
  return axios
    .post(`${API_ENDPOINTS.INSTALLATION}/${installationOrder._id}/start`)
    .then((res) => {
      dispatch({
        type: ACTIONS.INSTALLATION.SET_STATUS_TO_IN_PROGRESS,
      });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.INSTALLATION.START_INSTALLATION_ORDER,
      });
    });
};

export const setSelectedInstallationOrder = (order) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEATILS,
    payload: order,
  });
};

export const getInstallationOrderDetails = (orderinstallationOrderId) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEATILS_START,
  });
  axios
    .get(`${API_ENDPOINTS.INSTALLATION}/${orderinstallationOrderId}`)
    .then((res) => {
      dispatch({
        type: ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEATILS,
        payload: { ...res.data },
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEATILS_FAILURE,
        payload: err,
      });
    });
};

export const deleteInstallationOrder = (selectedInstallationOrder) => (dispatch) => {
  axios
    .delete(`${API_ENDPOINTS.INSTALLATION}/${selectedInstallationOrder._id}`)
    .then((res) => {
      dispatch({
        type: ACTIONS.INSTALLATION.DELETE_INSTALLATION_ORDER,
        payload: selectedInstallationOrder,
      });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.INSTALLATION.DELETE_INSTALLATION_ORDER_FAILURE,
        payload: err,
      });
    });
};

export const fetchSelectedInstallationOrderDevices = (orderinstallationOrderId) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEVICES_START,
  });
  axios
    .get(`${API_ENDPOINTS.INSTALLATION}/${orderinstallationOrderId}/devices`)
    .then((res) => {
      dispatch({
        type: ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEVICES,
        payload: [...res.data],
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEVICES_FAILURE,
        payload: err,
      });
    });
};

export const updateDeviceNote = (selectedInstallationOrderDetails, selectedInstallationOrderDevice) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.UPDATE_ORDER_DEVICE_NOTE_START,
  });
  return axios
    .patch(
      `${API_ENDPOINTS.INSTALLATION}/${selectedInstallationOrderDetails._id}/devices/${selectedInstallationOrderDevice._id}/save_note`,
      { note: selectedInstallationOrderDevice.deviceInstallationOrder.note }
    )
    .then((res) => {
      dispatch({
        type: ACTIONS.INSTALLATION.UPDATE_ORDER_DEVICE_NOTE,
        payload: { ...res.data },
      });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.INSTALLATION.UPDATE_ORDER_DEVICE_NOTE_FAILURE,
        payload: err,
      });
    });
};

export const getDeviceInstallationOrderAttachmentsList =
  (selectedInstallationOrderDetails, selectedInstallationOrderDevice) => (dispatch) => {
    dispatch({
      type: ACTIONS.INSTALLATION.GET_DEVICE_INSTALLATION_ORDER_ATTACHMENTS_LIST_START,
    });
    return axios
      .get(
        `${API_ENDPOINTS.INSTALLATION}/${selectedInstallationOrderDetails._id}/devices/${selectedInstallationOrderDevice._id}/attachments`
      )
      .then((res) => {
        dispatch({
          type: ACTIONS.INSTALLATION.GET_DEVICE_INSTALLATION_ORDER_ATTACHMENTS_LIST,
        });
        return res.data;
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.INSTALLATION.GET_DEVICE_INSTALLATION_ORDER_ATTACHMENTS_LIST_FAILURE,
          payload: err,
        });
      });
  };

export const uploadFileToDevice =
  (attachment, selectedInstallationOrderDetails, selectedInstallationOrderDevice) => (dispatch) => {
    return axios
      .post(
        `${API_ENDPOINTS.INSTALLATION}/${selectedInstallationOrderDetails._id}/devices/${selectedInstallationOrderDevice._id}/attachments`,
        attachment
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  };

export const updateInstallationOrderDetails = (newData, selectedInstallationOrderDetails) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.UPDATE_INSTALLATION_ORDER_DEVICE_START,
  });
  return axios
    .patch(`${API_ENDPOINTS.INSTALLATION}/${selectedInstallationOrderDetails._id}`, {
      name: newData.name ? newData.name : selectedInstallationOrderDetails.name,
      owner: newData.owner ? newData.owner._id : selectedInstallationOrderDetails.owner._id,
      note: newData.note !== null ? newData.note : selectedInstallationOrderDetails.note,
      serviceCenter: newData.serviceCenter ? newData.serviceCenter._id : selectedInstallationOrderDetails.serviceCenter._id,
      technician: newData.technician ? newData.technician._id : selectedInstallationOrderDetails.technician._id,
      dueDate: newData.dueDate ? newData.dueDate : selectedInstallationOrderDetails.dueDate,
      integrationEnabled: newData.integrationEnabled,
      integrationOrgs: newData.integrationOrgs,
    })
    .then((res) => {
      dispatch({
        type: ACTIONS.INSTALLATION.UPDATE_INSTALLATION_ORDER_DEVICE,
        payload: { ...res.data.installationOrder },
      });
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.INSTALLATION.UPDATE_INSTALLATION_ORDER_DEVICE_FAILURE,
        payload: err,
      });
    });
};

export const deleteInstallationOrderDevice =
  (selectedInstallationOrderDevice, selectedInstallationOrderDetails) => (dispatch) => {
    axios
      .delete(
        `${API_ENDPOINTS.INSTALLATION}/${selectedInstallationOrderDetails._id}/devices/${selectedInstallationOrderDevice._id}`
      )
      .then((res) => {
        dispatch({
          type: ACTIONS.INSTALLATION.DELETE_INSTALLATION_ORDER_DEVICE,
          payload: { ...res.data },
        });
        fetchSelectedInstallationOrderDevices(selectedInstallationOrderDetails._id)(dispatch);
        return res.data;
      })
      .catch((err) => {
        dispatch({
          type: ACTIONS.INSTALLATION.DELETE_INSTALLATION_ORDER_DEVICE_FAILURE,
          payload: err,
        });
      });
  };

export const deleteInstallationOrderDeviceAttachments =
  (selectedInstallationOrderDevice, selectedInstallationOrderDetails, attachment) => (dispatch) => {
    return axios
      .delete(
        `${API_ENDPOINTS.INSTALLATION}/${selectedInstallationOrderDetails._id}/devices/${selectedInstallationOrderDevice._id}/attachments/${attachment._id}`
      )
      .then((res) => res)
      .catch((err) => err);
  };

export const addDevicesToInstallationOrder = (selectedInstallationOrderDetails, selectedDevices) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.GET_INSTALLATION_ORDER_DEVICES_START,
  });

  return axios
    .post(`${API_ENDPOINTS.INSTALLATION}/${selectedInstallationOrderDetails._id}/devices`, { devices: selectedDevices })
    .then((res) => {
      return res;
    });
};

export const fetchAllInstallationOrdersOwners = () => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_OWNER_START,
  });
  axios
    .get(`${API_ENDPOINTS.INSTALLATION}/owners`)
    .then((res) => {
      dispatch({
        type: ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_OWNER,
        payload: [...res.data],
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_OWNER_FAILURE,
        payload: err,
      });
    });
};

export const fetchAllInstallationOrdersTechnicians = () => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_TECHNICIANS_START,
  });
  axios
    .get(`${API_ENDPOINTS.INSTALLATION}/technicians`)
    .then((res) => {
      dispatch({
        type: ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_TECHNICIANS,
        payload: [...res.data],
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: ACTIONS.INSTALLATION.GET_ALL_INSTALLATION_ORDER_TECHNICIANS_FAILURE,
        payload: err,
      });
    });
};
// ========================== installation Process
export const setWizardActiveStep = (stepName) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.SET_WIZARD_ACTIVE_STEP,
    payload: stepName,
  });
};

export const setSelectedDeviceToStartInstallation = (device) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.SET_SELECTED_DEVICE_TO_INSTALL,
    payload: device,
  });
};
export const getDeviceDetailsToIstall = (orderId, deviceId) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.SET_SELECTED_DEVICE_TO_INSTALL_START,
  });
  axios.get(`${API_ENDPOINTS.DEVICES}/${deviceId}`).then((dRes) =>
    getDeviceInstallationOrderAttachmentsList(
      { _id: orderId },
      { _id: deviceId }
    )(dispatch).then((aRes) => {
      dispatch({
        type: ACTIONS.INSTALLATION.SET_SELECTED_DEVICE_TO_INSTALL,
        payload: {
          deviceData: dRes.data,
          deviceAttachments: aRes,
        },
      });
    })
  );
};

export const setSelectedDeviceToInstall = (newDeviceObj) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.SET_DEVICE_INSTALL_DATA,
    payload: newDeviceObj,
  });
};

export const submitInstallDevice = (selectedInstallationOrderDetails, deviceInstallationPayload) => (dispatch) => {
  dispatch({
    type: ACTIONS.INSTALLATION.SUBMIT_INSTALL_DEVICE_START,
  });
  return axios
    .put(
      `${API_ENDPOINTS.INSTALLATION}/${selectedInstallationOrderDetails._id}/devices/${deviceInstallationPayload._id}/install`,
      {
        geo: deviceInstallationPayload.geo,
        name: deviceInstallationPayload.name,
        note: deviceInstallationPayload.note,
        placeName: deviceInstallationPayload.placeName,
        isComplete: deviceInstallationPayload.isComplete,
        properties: deviceInstallationPayload.properties,
        serialNumber: deviceInstallationPayload.serialNumber,
        isUnsuccessful: deviceInstallationPayload.isUnsuccessful,
        locationTypeStancode: deviceInstallationPayload.locationTypeStancode,
      }
    )
    .then((res) => {
      dispatch({
        type: ACTIONS.INSTALLATION.SUBMIT_INSTALL_DEVICE,
        payload: res.data,
      });
      if (deviceInstallationPayload.pictures.length) {
        dispatch({
          type: ACTIONS.INSTALLATION.ADDING_IMAGES_DEVICE_INSTALLATION_START,
        });

        const promiseArray = deviceInstallationPayload.pictures.map((img) => {
          const fileExt = img.name.split(".").pop().toLowerCase();
          const mimeType = img.type.split("/").shift().toLowerCase();
          if (fileExt !== "heic" && mimeType === "image") {
            imageCompressor
              .compress([img], {
                quality: 0.75,
                rotate: true,
              })
              .then((results) => {
                const file = Compress.convertBase64ToFile(results[0].data, results[0].imgExt);
                const attachmentData = new FormData();
                attachmentData.append("images", file, img.name);
                return axios.post(`${API_ENDPOINTS.DEVICES}/${deviceInstallationPayload._id}/images`, attachmentData);
              });
          } else {
            const attachmentData = new FormData();
            attachmentData.append("images", img);
            return axios.post(`${API_ENDPOINTS.DEVICES}/${deviceInstallationPayload._id}/images`, attachmentData);
          }
        });
        return axios
          .all(promiseArray)
          .then((res) => {
            return dispatch({
              type: ACTIONS.INSTALLATION.ADDING_IMAGES_DEVICE_INSTALLATION,
              payload: res.data,
            });
          })
          .catch(() => {
            return dispatch({
              type: ACTIONS.INSTALLATION.ADDING_IMAGES_DEVICE_INSTALLATION_FAILURE,
            });
          });
      }
    })
    .catch(() => {
      return dispatch({
        type: ACTIONS.INSTALLATION.SUBMIT_INSTALL_DEVICE_FAILURE,
      });
    });
};

export const filterInstallationOrdersList = (list, query) => (dispatch) => {
  return list.filter((item) => {
    return (
      ("technician" in item &&
        item.technician &&
        "user" in item.technician &&
        item.technician &&
        "name" in item.technician &&
        item.technician.name &&
        item.technician.name.toLowerCase().includes(query)) ||
      ("service_center" in item &&
        item.service_center &&
        "name" in item.service_center &&
        item.service_center.name &&
        item.service_center.name.toLowerCase().includes(query)) ||
      ("owner" in item &&
        item.owner &&
        "name" in item.owner &&
        item.owner.name &&
        item.owner.name.toLowerCase().includes(query)) ||
      ("devices" in item &&
        item.devices &&
        item.devices.length > 0 &&
        item.devices.find((d) => d.name.toLowerCase().includes(query) || d.device.toLowerCase().includes(query)) !== undefined) ||
      ("created_at" in item && item.created_at.toLowerCase().includes(query)) ||
      ("dueDate" in item && item.dueDate.toLowerCase().includes(query))
    );
  });
};

export const getInstallationOrderStatuses = () => (dispatch) => {
  return axios
    .get(`${API_ENDPOINTS.INSTALLATION}/statuses`)
    .then((res) => res.data)
    .catch((err) => err);
};
